import { Button as BaseButton, buttonVariants } from "../../../components/ui/button";

export const Button = BaseButton;
export { buttonVariants };

